import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Toaster } from "@/components/ui/sonner";
import Home from './pages/Home';
import IntroToCS from './pages/IntroToCS';
import IntroToCSample from './pages/IntroToCSample';
import DataStruct from './pages/DataStruct';
import Courses from './pages/Courses';
import HowItWorks from './pages/HowItWorks';
import ComingSoon from './pages/ComingSoon';
import ComingSoonDataStruct from './pages/ComingSoonDataStruct';
import ComingSoonJavaProgramming from './pages/ComingSoonJavaProgramming';
import ComingSoonKids from './pages/ComingSoonKids';
import ComingSoonLanguage from './pages/ComingSoonLanguage';
import ComingSoonCareer from './pages/ComingSoonCareer';
import ComingSoonPresentation from './pages/ComingSoonPresentation';
import DynamicCoursePage from './pages/DynamicCoursePage';
import Partners from './pages/Partners';
import MeetFounder from './pages/MeetFounder';
import About from './pages/About';
import Team from './pages/Team';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import ProfileModern from './pages/ProfileModern';
import ProfileAnalytics from './pages/ProfileAnalytics';
import TeacherProfile from './pages/TeacherProfile';
import AdminDashboard from './pages/AdminDashboard';
import RequireAuth from './components/RequireAuth';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Support from './pages/Support';

// Component to handle password recovery redirect
function RecoveryRedirectHandler({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if we're on homepage with recovery hash
    if (location.pathname === '/' && location.hash) {
      const hashParams = new URLSearchParams(location.hash.substring(1));
      const accessToken = hashParams.get('access_token');
      const type = hashParams.get('type');
      
      if (accessToken && type === 'recovery') {
        // Navigate to reset-password with the hash
        navigate(`/reset-password${location.hash}`, { replace: true });
      }
    }
  }, [location, navigate]);

  return children;
}

export default function App() {
  return (
    <Router>
      <RecoveryRedirectHandler>
        <Routes>
          <Route path="/" element={<Home />} />
        <Route path="/introtocs" element={<IntroToCS />} />
        <Route path="/introtocssample" element={<IntroToCSample />} />
        <Route path="/datastructures" element={<DataStruct />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/meet-founder" element={<MeetFounder />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Protected Routes */}
        <Route path="/profile" element={
          <RequireAuth>
            <ProfileAnalytics />
          </RequireAuth>
        } />
        <Route path="/teacher-profile" element={
          <RequireAuth>
            <TeacherProfile />
          </RequireAuth>
        } />
        <Route path="/admin" element={
          <RequireAuth>
            <AdminDashboard />
          </RequireAuth>
        } />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/support" element={<Support />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/coming-soon-kids" element={<ComingSoonKids />} />
        <Route path="/coming-soon-datastruct" element={<ComingSoonDataStruct />} />
        <Route path="/coming-soon-java" element={<ComingSoonJavaProgramming />} />
        <Route path="/coming-soon-language" element={<ComingSoonLanguage />} />
        <Route path="/coming-soon-career" element={<ComingSoonCareer />} />
        <Route path="/coming-soon-presentation" element={<ComingSoonPresentation />} />
        
        {/* Dynamic Course Page - catches /course/:courseId */}
        <Route path="/course/:courseId" element={<DynamicCoursePage />} />
      </Routes>
      </RecoveryRedirectHandler>
      <Toaster />
    </Router>
  );
}
